import videojs from 'video.js';
import utils from './like-button-utils.js';
const Component = videojs.getComponent('Component');
//const ClickableComponent = videojs.getComponent('ClickableComponent');

const dom = videojs.dom || videojs;

const DEFAULTS = {
  url_vote: '',
  url_info: ''
};


/**
 * The button component for showing moments settings form
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends Button
 */
class likeButton extends Component {
  constructor(player, options) {
    super(player, options);
    console.log(options);
    this.votes = 0;
    this.counter_el = null;
    this.user_voted = true;
    this.init();
  }

  init() {
    this.hide();

    this.getInfo().then((res) => {
      this.user_voted = res.user_voted;
      this.votes = res.votes_count || 0;
      let votes_formated = utils.formatDigit(this.votes);
      dom.insertContent(this.$('.vjs-like-button-counter'), '' + votes_formated);
      this.user_voted ? this.addClass('vjs-like-button-control_disabled') : this.removeClass('vjs-like-button-control_disabled');
      window.postMessage({
        event: 'vjs_vote_btn_loaded',
        is_voted: this.user_voted,
        votes: votes_formated
      }, '*');
      this.show();
    }, (err) => {
      console.log('getInfo err: ' + err);
    });

    this.setListeners_();
  }

  setListeners_() {
    let handlerClick = () => {
      if (!this.canVote()) return;
      this.vote();
      if (!window.dataLayer) return;
      window.dataLayer.push({
        event: 'event',
        eventCategory: 'cocacolakhl',
        eventAction: 'zhmi_button',
        eventLabel: window.location.href
      });
    };

    this.on(this.$('.vjs-like-button-btn'), 'click', handlerClick);
    window.addEventListener('message', (msg) => {
      if (msg.data.event === 'vjs_vote_btn_click') handlerClick();
    });
  }

  createEl() {
    let el = dom.createEl('div', {
      className: 'vjs-like-button-control vjs-like-button-control_disabled'
    });

    let btn = dom.createEl('div', {
      className: 'vjs-like-button-btn'
    });

    let counter = dom.createEl('div', {
      className: 'vjs-like-button-counter'
    });

    let title = dom.createEl('div', {
      className: 'vjs-like-button-title'
    });

    dom.appendContent(el,
      [btn,
      counter, 
      title]);

    return el;
  }

  vote() {
    this.user_voted = true;
    dom.insertContent(this.$('.vjs-like-button-counter'),  utils.formatDigit(++this.votes));
    this.addClass('vjs-like-button-control_disabled');

    window.postMessage({event: 'vjs_vote_player_btn_click'}, '*');

    utils.makeRequest(this.options_.url_vote);        
  }

  canVote() {
    return !this.user_voted;
  }

  getInfo() {
    let link = this.options_.url_info;
    return utils.makeRequest(link);
  }

  showText() {
    this.removeClass('vjs-like-button-control_hide-text');
  }

  hideText() {
    this.addClass('vjs-like-button-control_hide-text');
  }
}

Component.registerComponent('likeButton', likeButton);
export default likeButton;
